import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { SwipeDot } from '@src/components/swipe-dot'

import './index.sass'

@Component
export class SwipeDots extends Vue {

  @Prop({ required: true })
  private activeIndex: number

  @Prop({ required: true })
  private count: number

  render (h: CreateElement) {
    return (
      <div class='swipe-dots'>
        {[...Array(this.count).fill(null)].map((element, index) => (
          <SwipeDot active={this.activeIndex === index}/>
        ))}
      </div>
    )
  }
}
